<div id="demographics" class="registration container">
  <form #demographicsForm="ngForm" [ngClass]="{'form-complete': demographicsForm.valid }"
    (ngSubmit)="forward(demographicsForm)" novalidate autocomplete="off" appScrollToInvalid
    [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.DEMOGRAPHICS.heading' | copy | async }}</h1>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.subheading' | copy | async }}
        </div>
      </div>

      <article>
        <div class="card-body w-100">
          <div class="w-100 required">
            <label class="w-100" for="firstTime"
              aria-labelledby="firstTime">{{'copy.label.DEMOGRAPHICS.firsttimeattending'|copy|async}}
              <!-- <i class="fas fa-asterisk required"></i> --></label>
            <!-- <app-radio-group></app-radio-group> -->
            <mat-radio-group class="w-100" [(ngModel)]="firstTime.Value" name="firstTimeValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-label class="required" for="bestDesc"
            aria-labelledby="bestDesc">{{'copy.label.DEMOGRAPHICS.bestdescribes' | copy | async}}
            <!-- <i class="fas fa-asterisk required"></i> -->
          </mat-label>
          <mat-form-field class="w-100 required">
            <mat-label class="required" for="agedec"
              aria-labelledby="agedec">{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select placeholder="{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}" name="agedesc" id="agedec"
              aria-label="agedec" [(ngModel)]="ageRange.Value" required>
              <mat-option *ngFor="let obj of ages" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-100 required">
            <mat-label class="required" for="genderdec"
              aria-labelledby="genderdec">{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select placeholder="{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}" name="genderdec"
              id="genderdec" aria-label="genderdec" [(ngModel)]="gender.Value" required>
              <mat-option *ngFor="let obj of genders" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 genderOther" *ngIf="gender.Value === 'Other'">
            <mat-label for="genderOther">{{ '
              copy.label.DEMOGRAPHICS.otherspecify' |
              copy | async }}</mat-label>
            <input matInput name="genderOther" id="genderOther" [attr.aria-label]="genderOther" type="text"
              maxlength="25" pattern="^[\w\s!@\-\_:'&,.\/?]*$" [(ngModel)]="otherGender" #genderOther="ngModel"
              required />
            <mat-error><app-validation [object]="genderOther" isRequired=true
                pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="required" for="eth"
              aria-labelledby="eth">{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select placeholder="{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}" name="eth" id="eth"
              aria-label="eth" [(ngModel)]="ethnicity.Value" required>
              <mat-option *ngFor="let obj of ethnicities" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 ethOther" *ngIf=" ethnicity.Value === 'Other'">
            <mat-label for="ethOther">{{ '
              copy.label.DEMOGRAPHICS.otherspecify' |
              copy | async }}</mat-label>
            <input matInput name="ethOther" id="ethOther" [attr.aria-label]="ethOther" type="text" maxlength="25"
              pattern="^[\w\s!@\-\_:'&,.\/?]*$" [(ngModel)]="ethnicityOther" #ethOther="ngModel" required />
            <mat-error><app-validation [object]="ethOther" isRequired=true
                pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>

          <mat-label class="required" for="bestDesc"
            aria-labelledby="bestDesc">{{'copy.label.DEMOGRAPHICS.bestdescribesbusiness' | copy | async}}
            <!-- <i class="fas fa-asterisk required"></i> -->
          </mat-label>

          <mat-form-field class="w-100 required">
            <mat-label class="required" for="role"
              aria-labelledby="role">{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select placeholder="{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}" name="role" id="role"
              aria-label="role" [(ngModel)]="jobRole.Value" required>
              <mat-option *ngFor="let obj of jobRoles" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="required" for="employeeNum"
              aria-labelledby="employeeNum">{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select placeholder="{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}" name="employeeNum"
              id="employeeNum" aria-label="employeeNum" [(ngModel)]="numEmployees.Value" required>
              <mat-option *ngFor="let obj of numbers" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="required" for="financialEx"
              aria-labelledby="financialEx">{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select placeholder="{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}" name="financialEx"
              id="financialEx" aria-label="financialEx" [(ngModel)]="financialExperience.Value" required>
              <mat-option *ngFor="let obj of experiences" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="required" for="aum"
              aria-labelledby="aum">{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select placeholder="{{'copy.label.DEMOGRAPHICS.selectone' | copy | async}}" name="aum" id="aum"
              aria-label="aum" [(ngModel)]="averageAum.Value" required>
              <mat-option *ngFor="let obj of aums" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 required">
            <mat-label class="required" for="busaffil"
              aria-labelledby="busaffil">{{'copy.label.DEMOGRAPHICS.busaffiliation' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select name="busaffil" id="busaffil" aria-label="busaffil" [(ngModel)]="businessAffiliation.Value"
              required>
              <mat-option *ngFor="let obj of affiliations" [value]="obj.value">
                {{obj.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="w-100">
            {{ 'copy.label.DEMOGRAPHICS.investmentstrategy' | copy | async }}
            <div *ngFor="let strategies of investmentStrategies">
              <div class="agreeCheckbox my-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="strategies_{{ strategies.name }}"
                    [ngModel]="includes(attendee.$mtcChosenStrategies,strategies.code)" (change)="strategyUpdate(strategies)"
                    aria-labelledby="{{ strategies.code }}_label"></mat-checkbox>
                  <label id="{{ strategies.code }}_label">{{ strategies.name }}</label>
                  <!-- {{personalConsiderations.invalid}} -->
                </div>
              </div>
            </div>
          </div>

          <mat-form-field class="w-100 ai" *ngIf=" this.attendee.$mtcChosenStrategies.includes('Alternative Investments')">
            <mat-label for="ai">{{ '
              copy.label.DEMOGRAPHICS.aivehicles' |
              copy | async }}</mat-label>
            <input matInput name="ai" id="ai" [attr.aria-label]="ai" type="text" maxlength="100"
              pattern="^[\w\s!@\-\_:'&,.\/?]*$" [(ngModel)]="aiVehicles.Value" #ai="ngModel" required />
            <mat-error><app-validation [object]="ai" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>

          <mat-form-field class="w-100 sma" *ngIf=" this.attendee.$mtcChosenStrategies.includes('SMAs')">
            <mat-label for="sma">{{ '
              copy.label.DEMOGRAPHICS.sma' |
              copy | async }}</mat-label>
            <input matInput name="sma" id="sma" [attr.aria-label]="sma" type="text" maxlength="100"
              pattern="^[\w\s!@\-\_:'&,.\/?]*$" [(ngModel)]="smaStrat.Value" #sma="ngModel" required />
            <mat-error><app-validation [object]="sma" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>

        </div>
      </article>
    </section>

    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.partnereventcomm' | copy | async }}
        </div>
      </div>

      <article>
        <div class="card-body w-100">

          <div class="w-100 required">
            <label class="w-100" for="digital"
              aria-labelledby="digital">{{'copy.label.DEMOGRAPHICS.receivingdigitalonbreakout'|copy|async}}
              <!-- <i class="fas fa-asterisk required"></i> --></label>
            <!-- <app-radio-group></app-radio-group> -->
            <mat-radio-group class="w-100" [(ngModel)]="receiveDigital.Value" name="digital" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="w-100 required">
            <label class="is-orphan" for="digitalSP"
              aria-labelledby="digitalSP">{{'copy.label.DEMOGRAPHICS.receivingdigitaloncecredit'|copy|async}}
              <!-- <i class="fas fa-asterisk required"></i> --></label>
            <!-- <app-radio-group></app-radio-group> -->
            <mat-radio-group class="w-100" [(ngModel)]="digitalCredit.Value" name="digitalSP" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field class="w-100 required">
            <mat-label class="required" for="prefContact"
              aria-labelledby="prefContact">{{'copy.label.DEMOGRAPHICS.prefcontactmethod' | copy | async}}
              <!-- <i class="fas fa-asterisk required"></i> -->
            </mat-label>
            <mat-select name="prefContact" id="prefContact" aria-label="prefContact" [(ngModel)]="contactMethod.Value"
              required>
              <mat-option *ngFor="let obj of contactMethods" [value]="obj.code">
                {{obj.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>


        </div>
      </article>
    </section>

    
    <section class="card" *ngIf="attendee.PAXTypeNo != 4">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.braindateheader' | copy | async }}
        </div>
      </div>
      <article>
        <div class="card-body w-100">
          <div class="w-100 required">
            <label class="w-100 required" [innerHTML]='"copy.html.braindatequestion" | copy | async '></label>
            <mat-radio-group class="w-100" [(ngModel)]="braindate.Value" required #braindates="ngModel"
              name="braindates">
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
              <div class="w-100">
                <small class="text-danger"><app-validation [object]="braindates" isRequired=true></app-validation></small>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </article>
    </section>


    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()"
        *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
      </button>
      <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>